import Headroom from 'headroom.js';

const header = document.querySelector('header');
const alerts = document.querySelector('.alerts');

const getAlertsHeight = () => {
    if (!alerts) return 0;
    return alerts.offsetHeight;
};

const headroom = new Headroom(header, {
    offset: getAlertsHeight() + header.offsetHeight,
});

headroom.init();
